/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC } from 'react'
import { Chip } from '@mui/material'
import Autosuggest, { AutosuggestProps } from 'components/Autosuggest'
import * as questionPickerClasses from 'components/QuestionPicker/styles'
import { findAllForCMSTask_findAllForCMSTask_items as Task } from '__generatedTypes__/findAllForCMSTask'
import * as listClasses from 'pagesNew/StudySchedule/List/styles'
import { TASK_TYPE_TITLE } from '../consts'
import { ALL_SUBJECT_ID } from '../List/useTaskFilters'
import * as classes from './styles'

export type Props = Omit<AutosuggestProps<Task>, 'changeImmediately' | 'multiple' | 'searchable'> & {
  excludeIds: string[]
}

const defaultRenderTask: AutosuggestProps<Task>['renderItem'] = (task) => (
  <div css={classes.autocompleteItem}>
    <Typography variant="body2" css={classes.taskTitle}>
      {task.title}
    </Typography>

    <div css={classes.actions}>
      {task.subject ? (
        <div css={listClasses.chipWrapper(task.subject.tabName)}>
          <Chip label={task.subject?.tabName} css={listClasses.subjectChip(task.subject.tabName)} />
        </div>
      ) : (
        <div css={listClasses.chipWrapper(ALL_SUBJECT_ID)}>
          <Chip label="All" css={listClasses.subjectChip(ALL_SUBJECT_ID)} />
        </div>
      )}
      <div>
        <Chip label={TASK_TYPE_TITLE[task.type]} css={classes.chip} />
      </div>
    </div>
  </div>
)

export const PhasePicker: FC<Props> = ({
  renderItem = defaultRenderTask,
  placeholder = 'Tasks',
  excludeIds,
  ...props
}) => (
  <Autosuggest<Task>
    popperCss={questionPickerClasses.withPlatformsStyles}
    {...props}
    getItemLabel={(task) => task.title}
    renderItem={renderItem}
    placeholder={placeholder}
    changeImmediately
    multiple
    searchable
    data-testid="tasks-picker"
    disabledItemIds={excludeIds}
  />
)
